import React from 'react'
import { SETTINGS_SUBMENU } from 'constants/menu/submenus'
import { EMPTY_SALES_CHANNEL } from 'constants/objects/sales-channel'
import {
  requestSalesChannelsList,
  requestSalesChannelsUpdate,
  requestSalesChannelsCreate,
} from 'requests/sales-channels'
import useSimpleList from 'hooks/useSimpleList'
import { ListPage } from 'templates/ListPage'
import { SideMenu } from 'components/SideMenu'
import { SalesChannel } from './components/SalesChannel'
import { Form } from './components/Form'

export default function SalesChannels() {
  const [salesChannels, listState, listActions] = useSimpleList({
    requestList: requestSalesChannelsList,
    requestCreate: requestSalesChannelsCreate,
    requestUpdate: requestSalesChannelsUpdate,
  })

  const renderForm = () => (
    <Form
      salesChannel={listState.currentItem || EMPTY_SALES_CHANNEL}
      onCancel={() => listActions.onToggleForm(false)}
      onSave={listActions.save}
      saving={listState.saving}
      responseError={listState.responseError}
    />
  )

  const renderMenu = () => (
    <SideMenu submenu={SETTINGS_SUBMENU} />
  )

  const renderSalesChannel = (salesChannel) => (
    <SalesChannel
      key={salesChannel.id}
      salesChannel={salesChannel}
      onClick={listActions.selectItem}
    />
  )

  return (
    <ListPage
      renderForm={renderForm}
      renderMenu={renderMenu}
      listTitle="Canais de venda"
      onClickPagination={() => {}}
      pagination={listState.pagination}
      loading={listState.loading}
      showForm={listState.showForm}
      onToggleForm={listActions.onToggleForm}
      showAddButton
    >
      { salesChannels.map(renderSalesChannel) }
    </ListPage>
  )
}
